import React from 'react'
import { Button } from '@mui/material'
import { useSnackbar } from 'notistack'
import {
  useGetEndUserScratchCardById,
  usePatchEndUserScratchCardApprove,
} from '../../../../../api/promotions/end-user/end-user-scratch-card'

const ApproveButton = ({ id }) => {
  const { mutateAsync, isLoading } = usePatchEndUserScratchCardApprove(id)

  const { refetch } = useGetEndUserScratchCardById(id)

  const { enqueueSnackbar } = useSnackbar()

  const handleApprove = async () => {
    try {
      const res = await mutateAsync()

      // Display success on popup
      enqueueSnackbar(`Approved successfully`, {
        variant: 'success',
      })

      // Refetch data
      refetch()
    } catch (error) {
      // Display error on popup
      enqueueSnackbar(error?.response?.data?.message ?? 'Failed to approve', {
        variant: 'error',
        autoHideDuration: 7000,
      })
    }
  }

  return (
    <Button
      variant='contained'
      size='large'
      color='success'
      disabled={isLoading}
      onClick={handleApprove}
    >
      Approve
    </Button>
  )
}

export default ApproveButton
